export default __webpack_public_path__ + "static/media/Flag_of_Belarus.a7e84d22.svg";